import React from "react";
import styled from "styled-components";

interface LoaderProps {
    size?: number;
    animationDuration?: number;
    color?: string;
    className?: string;
    style?: object;
}

const LoadingSpinner = styled.div`
    height: ${(props) => props.size}px;
    width: ${(props) => props.size}px;

    font-size: 10px;
    margin: 50px auto;
    text-indent: -9999em;
    border-radius: 50%;
    background: ${(props) => props.color};
    background: -moz-linear-gradient(left, ${(props) => props.color} 10%, rgba(0, 0, 0, 0) 42%);
    background: -webkit-linear-gradient(left, ${(props) => props.color} 10%, rgba(0, 0, 0, 0) 42%);
    background: -o-linear-gradient(left, ${(props) => props.color} 10%, rgba(0, 0, 0, 0) 42%);
    background: -ms-linear-gradient(left, ${(props) => props.color} 10%, rgba(0, 0, 0, 0) 42%);
    background: linear-gradient(to right, ${(props) => props.color} 10%, rgba(0, 0, 0, 0) 42%);
    position: relative;
    -webkit-animation: load3 1.4s infinite linear;
    animation: load3 1.4s infinite linear;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);

    :before {
        width: 50%;
        height: 50%;
        background: ${(props) => props.color};
        border-radius: 100% 0 0 0;
        position: absolute;
        top: 0;
        left: 0;
        content: "";
    }
    :after {
        background: #ffffff;
        width: 75%;
        height: 75%;
        border-radius: 50%;
        content: "";
        margin: auto;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }
    @-webkit-keyframes load3 {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
    @keyframes load3 {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
`;

const defaultProps = {
    size: 50,
    color: "#212529",
    animationDuration: 2000,
    className: "",
};

LoadingSpinner.className = "loader mx-auto";

LoadingSpinner.defaultProps = defaultProps;

export default LoadingSpinner;
